// extracted by mini-css-extract-plugin
module.exports = {"accordion-group":"AccordionGroup_accordion-group__MHa_6","accordion-group-content":"AccordionGroup_accordion-group-content__NcYbd"};